import ViewSalesCreditNote from "../../../../components/@documents/sales_credit_notes/ViewSalesCreditNote";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesCreditNoteViewPage() {

    return (
        <ViewSalesCreditNote 
            routeType={routeTypes.admin}
        />
    )
}